import { Navbar } from '@/components/layout/Navbar';
import { useTranslation } from 'react-i18next';
import { Footer } from '@/components/layout/Footer';

export default function Privacy() {
  const { t } = useTranslation();

  // Key stems only — the section copy lives in locales/{en,es}.json so the
  // policy re-renders in the reader's language.
  // 'children' covers the AI Storybook (a picture book personalized for a child).
  const sections = ['collect', 'use', 'retention', 'training', 'advertising', 'cookies', 'security', 'children', 'rights', 'choices'];



  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="pt-16">
        <section className="py-16">
          <div className="container mx-auto px-4 max-w-3xl">
            <h1 className="text-3xl md:text-4xl font-bold mb-6">{t('legal.privacyPolicy')}</h1>
            <p className="text-muted-foreground mb-8">
              {t('legal.privacyIntro')}
            </p>
            <div className="space-y-8">
              {sections.map((section) => (
                <section key={section} className="space-y-3">
                  <h2 className="text-xl font-semibold">{t(`legal.privacySections.${section}Title`)}</h2>
                  <p className="leading-7 text-muted-foreground">{t(`legal.privacySections.${section}Body`)}</p>
                </section>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}

